export const EVENT_TYPE = {
  CHAT: 'chat',
  HISTORY: 'history'
};
